import request from '@/utils/request'

// 调查问卷start
export function fetchNaireQuestionOptions() {
  return request({
    url: '/merchant-api/question/naireQuestionOptions',
    method: 'get'
  })
}

export function fetchNaireTitle() {
  return request({
    url: '/merchant-api/question/naireTitle',
    method: 'get'
  })
}

export function sendNaireAnswer(data) {
  return request({
    url: '/merchant-api/naireAnswer',
    method: 'post',
    data
  })
}

// 调查问卷end
